module.exports = __webpack_public_path__ + "media/images/default/banner_D-67b5624ab83846a8f142cbebd78f07ac.png";